import React, { useState } from "react";
import { Input, InputNumber } from "antd";
import { connect, useDispatch } from "react-redux";
import { getReprintItemApi } from "../../modules/actions/dataEntryActions";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";

const Reprint = (props) => {
    const [SearchNo, setSearchNo] = useState("");
    let { reprint_Data } = props;
    const addReprintItem = (item) => {
        let services = [{
            "report_id": 1,
            "report_name": "Diamond Grading Report"
        },
        {
            "report_id": 2,
            "report_name": "Gem Stone"
        },
        {
            "report_id": 3,
            "report_name": "Small Jewelry Report"
        },
        {
            "report_id": 4,
            "report_name": "Small Gemstone Report"
        },
        {
            "report_id": 5,
            "report_name": "Small Diamond Report"
        },
        {
            "report_id": 6,
            "report_name": "Small Gemstone Jewelry Report"
        }]
        let service = { name: "Small", price: 800 };
        let obj = {
            color: "",
            goldTestingRate: 0,
            item: "Reprint",
            jewelleryItems: "",
            mineRate: 0,
            quantity: 1,
            sealRate: 0,
            selectstoneValue: "",
            service: service,
            serviceRate: 800,
            urgentRate: 0,
            weight: "",
            weightDescription: "",
            weightRange: "",
            report_no: item.reportObj ? item.reportObj.entryNo : item.entryNo || "",
            report_id: item.report_id ? item.report_id : item.reportObj.report_id || "",
            cvdColorRate: 0,
            stoneArr: [],
        };
        props.addItem("save", obj);
    }
    return (
        <>

            <div className="inputFields">
                <label>
                    <h5>Enter slip no / Report no</h5>
                    <Input value={SearchNo} onChange={(ev) => setSearchNo(ev.target.value)} />
                </label>
            </div>
            <div className="inputFields searchBtn">
                <h5></h5>
                <button
                    type="button"
                    className="ant-btn ant-btn-primary"
                    style={{
                        background: "#001529",
                        color: "white",
                        borderColor: "#001529",
                    }}
                    onClick={() => { props.getReprintItemApi(SearchNo) }}
                >
                    <span>Search</span>
                </button>
            </div>
            {/* Data Entry Table */}
            {reprint_Data && reprint_Data.dataentry && Array.isArray(reprint_Data.items) && reprint_Data.items.length > 0 ? (
                <div className="reprint-items-table" style={{ marginTop: 24 }}>
                    <h5>Items</h5>
                    <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
                        <thead>
                            <tr style={{ background: '#f5f5f5' }}>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>#</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>Item</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>Service</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>Quantity</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>Weight</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>Color</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {reprint_Data.items.map((item, idx) => (
                                <tr key={item.id || idx}>
                                    <th style={{ border: '1px solid #ddd', padding: 8 }}>{item.reportObj ? <span onClick={() => console.log(item)}>•</span> : null} {idx + 1}</th>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}>{item.item}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}>{item.service}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}>{item.weight}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}>{item.color}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}> {item.reportObj ? <button onClick={() => addReprintItem(item)} type="button"
                                        className="ant-btn ant-btn-primary"
                                        style={{
                                            background: "#001529",
                                            color: "white",
                                            borderColor: "#001529",
                                        }}>Reprint</button> : null}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : null}

            {/* Report View */}
            {Array.isArray(reprint_Data) && reprint_Data.length > 0 && reprint_Data[0].report ? (
                <div className="reprint-report-table" style={{ marginTop: 24 }}>
                    <h5>Report</h5>
                    <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
                        <thead>
                            <tr style={{ background: '#f5f5f5' }}>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>Entry No</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>Description</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>Carat Weight</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}>Color</th>
                                <th style={{ border: '1px solid #ddd', padding: 8 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {reprint_Data.map((report, idx) => (
                                <tr key={report.id || idx}>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}>{report.entryNo}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}>{report.description}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}>{report.carat_weight} {report.weight_unit}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}>{report.color}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 8 }}><button onClick={() => addReprintItem(report)} type="button"
                                        className="ant-btn ant-btn-primary"
                                        style={{
                                            background: "#001529",
                                            color: "white",
                                            borderColor: "#001529",
                                        }}>Reprint</button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : null}

        </>
    )
}
const mapStateToProps = (store) => {
    return {
        reprint_Data: store.dataEntry.reprint_Data,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getReprintItemApi,
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Reprint));
